export const radio = {
  baseStyle: {
    control: {
      borderColor: 'divider.grey',
      _checked: {
        bg: 'fill.grey',
        borderColor: 'fill.grey',
        _hover: {
          bg: 'fill.grey',
          borderColor: 'fill.grey',
        },
      },
      _hover: {
        borderColor: 'text.light.grey',
      },
      _focus: {
        boxShadow: '0px 0px 6px 0px rgba(163,163,163,0.15)',
      },
    },
    label: {
      color: 'text.dark.grey',
      fontSize: '14px',
    },
  },
};
